// Configuração partilhada do formulário de requerimentos (criação e edição).

/** Motivos que exigem um documento comprovativo anexado para poder enviar. */
export const ANEXO_OBRIGATORIO: Record<string, { titulo: string, dica: string, erro: string }> = {
  'Atestado': {
    titulo: 'Anexar Atestado',
    dica: 'Selecione o arquivo do atestado médico (PDF ou imagem).',
    erro: 'Anexe o atestado para enviar o requerimento.',
  },
  'Nojo': {
    titulo: 'Anexar Atestado de Óbito',
    dica: 'Selecione o arquivo do atestado de óbito (PDF ou imagem).',
    erro: 'Anexe o atestado de óbito para enviar o requerimento.',
  },
  'Capacitação na Área': {
    titulo: 'Anexar Comprovante de Capacitação',
    dica: 'Selecione o comprovante de participação na capacitação (PDF ou imagem).',
    erro: 'Anexe o comprovante de capacitação para enviar o requerimento.',
  },
}

/**
 * Converte datas "AAAA-MM-DD" em ISO ao meio-dia UTC (evita recuar um dia
 * por causa do fuso horário), sem repetidas e por ordem cronológica.
 */
export function datasParaIso(datas: string[]): string[] {
  const unicas = Array.from(new Set(datas.filter(Boolean)))
  unicas.sort()
  return unicas.map(d => `${d}T12:00:00.000Z`)
}

/** Devolve as datas "AAAA-MM-DD" de um requerimento (suporta registos antigos com uma só data). */
export function datasDoProtocolo(p: { dataAbonada?: string, datasAbonadas?: string[] }): string[] {
  if (p.datasAbonadas && p.datasAbonadas.length > 0)
    return p.datasAbonadas.map(d => d.slice(0, 10))
  if (p.dataAbonada)
    return [p.dataAbonada.slice(0, 10)]
  return []
}
